// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SUaY","newExpiryDate":"styles_newExpiryDate__1cBnK","footer":"styles_footer__hEacq"};